import { render, staticRenderFns } from "./TagRouterList.vue?vue&type=template&id=525780f4&scoped=true&"
import script from "./TagRouterList.vue?vue&type=script&lang=js&"
export * from "./TagRouterList.vue?vue&type=script&lang=js&"
import style0 from "./TagRouterList.vue?vue&type=style&index=0&id=525780f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525780f4",
  null
  
)

export default component.exports